import axios from "axios";
import stringToStyles from '../helpers/contentBlocksStyles'

export const getContentBlock = async ( blockName ) => {

    try{
        let { data: { success = false, data = null } } = await axios.get(`/api/content/block/${blockName}`)
        
        if( success && data )  {
            let style = '';
            
            if( data.stylesheet ){
                let { stylesheet = '' } = data
                style += stylesheet + '\n'
            }

            if( data.category && data.category.stylesheet ){
                let { stylesheet = '' } = data.category
                style += stylesheet + '\n'
            }

            if( data.items && data.items.length ){

                data.items.forEach( item => {

                    if( item.stylesheet ) {
                        let { stylesheet = '' } = item
                        style += stylesheet + '\n'
                    }

                } )

            }

            if( style.length ) stringToStyles( style )

            return data
        }

    } catch ( e ){

      console.log(e)

    }

}